export default "__VITE_ASSET__BR0GVWXt__"